export const DISPLAY_SIZES = [
  { label: 'label.DISPLAY_SIZE_LARGE', value: 'large', zoom: 1.1, height: '91vh', class: 'zoom-large' },
  { label: 'label.DISPLAY_SIZE_DEFAULT', value: 'default', zoom: 'normal', height: '100vh', class: 'zoom-default' },
  { label: 'label.DISPLAY_SIZE_SMALL', value: 'small', zoom: 0.9, height: '111vh', class: 'zoom-small' },
  { label: 'label.DISPLAY_SIZE_EXTRA_SMALL', value: 'x-small', zoom: 0.8, height: '125vh', class: 'zoom-x-small' }
];

export const DEFAULT_SIZE = DISPLAY_SIZES[1];
